export default function PageHeader({ title, description, actions }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 border-b border-ink-200 bg-white px-8 py-6 dark:border-ink-800 dark:bg-ink-900">
      <div>
        <h1 className="text-2xl font-bold text-ink-900 dark:text-ink-50">{title}</h1>
        {description && (
          <p className="mt-1 max-w-2xl text-sm text-ink-500">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
